import {
  format_date_default
} from "../../chunks/chunk.WP5UNHWC.js";
import "../../chunks/chunk.QLGZEMOE.js";
import "../../chunks/chunk.6CTB5ZDJ.js";
import "../../chunks/chunk.7BTDLTNI.js";
import "../../chunks/chunk.4TUIT776.js";
import "../../chunks/chunk.KAW7D32O.js";
export {
  format_date_default as default
};
